import { render } from "./CertIframe.vue?vue&type=template&id=19471a12&ts=true"
import script from "./CertIframe.ts?vue&type=script&lang=ts&external"
export * from "./CertIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__